"use client";

import { Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <footer ref={ref} className="w-full bg-dark-background text-foreground-dark py-8 px-4">
      <div className="container mx-auto max-w-7xl">
        <div className={`grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-center transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <div className="text-center md:text-left">
            <p className="text-sm text-foreground-dark/80">
              © {new Date().getFullYear()} A+ Fire. All rights reserved.
            </p>
          </div>

          {}
          <nav className="flex justify-center">
            <ul className="flex flex-wrap gap-6 items-center justify-center">
              <li>
                <Link to="/HomePage" className="text-sm text-foreground-dark hover:text-primary transition-colors duration-[var(--duration-fast)]">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/ServicesPage" className="text-sm text-foreground-dark hover:text-primary transition-colors duration-[var(--duration-fast)]">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/AboutPage" className="text-sm text-foreground-dark hover:text-primary transition-colors duration-[var(--duration-fast)]">
                  About
                </Link>
              </li>
              <li>
                <Link to="/ContactPage" className="text-sm text-foreground-dark hover:text-primary transition-colors duration-[var(--duration-fast)]">
                  Contact
                </Link>
              </li>
            </ul>
          </nav>

          {}
          <div className="flex gap-4 justify-center md:justify-end">
            <Link to="#" className="text-foreground-dark hover:text-primary transition-all duration-[var(--duration-fast)] hover:scale-[1.02]" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="#" className="text-foreground-dark hover:text-primary transition-all duration-[var(--duration-fast)] hover:scale-[1.02]" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
            <Link to="#" className="text-foreground-dark hover:text-primary transition-all duration-[var(--duration-fast)] hover:scale-[1.02]" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}